import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { QbItaGenericErrorComponent } from '@fwmovilidad/qb-home-ita-components-lib';
import { QbItaDigitalDataErrorType } from '@core/models/digitalData.model';
import { AnalyticsService } from '../analytics/analytics.service';
import { IntegrationService } from '../integration/integration.service';

@Injectable({
  providedIn: 'root',
})
export class GenericErrorModalService {
  private seenInd = false;
  constructor(
    private readonly modalCtrl: ModalController,
    private readonly analyticsService: AnalyticsService,
    private readonly integrationService: IntegrationService
  ) {}

  async showUnexpectedErrorModal(errorMessage: string, errorType: QbItaDigitalDataErrorType): Promise<void> {
    if (!this.seenInd) {
      this.seenInd = true;
      this.modalCtrl
        .create({
          component: QbItaGenericErrorComponent,
          componentProps: {
            isModal: true,
            titleText: 'ERROR_PAGE.TITLE',
            descriptionEmailStart: 'ERROR_PAGE.DESCRIPTION.CONTACT_MAIL.START',
            descriptionEmailClickable: 'ERROR_PAGE.DESCRIPTION.CONTACT_MAIL.TEXT_CLICKABLE',
            descriptionEmailEnd: 'ERROR_PAGE.DESCRIPTION.CONTACT_MAIL.END',
            descriptionPhone: 'ERROR_PAGE.DESCRIPTION.CONTACT_PHONE',
            btnLabel: 'ERROR_PAGE.BUTTON',
            iconClose: 'verti-close-16',
          },
        })
        .then((modal: HTMLIonModalElement): void => {
          this.analyticsService.setErrorMessage(errorMessage);
          this.analyticsService.setErrorType(errorType);
          this.analyticsService.sendPopupView('generic-error');
          modal.present();
          modal.onDidDismiss().then(({ data }) => {
            this.seenInd = false;
            this.analyticsService.setErrorMessage('');
            this.analyticsService.setErrorType('');
            if (data?.mailContactIntegrationClick) {
              this.integrationService.integrateWithContactForm();
            }
          });
        });
    }
  }
}
